
<div ref="scrollContainer">
  <slot v-for="(item, index) in itemsToDisplay" :index="index" :item="item"/>
</div>
